import { GSEName, LoanInvestorName } from '@willow/types-iso';

export const isOwnerIdGSE = (ownerId?: string | null): ownerId is GSEName => GSEName.safeParse(ownerId).success;

/** Narrower check: true only for traditional investor names (FNMA, FHLMC, GNMA) — excludes FHA */
export const isOwnerIdLoanInvestor = (ownerId?: string | null): ownerId is LoanInvestorName =>
  LoanInvestorName.safeParse(ownerId).success;
